import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'
import NonHomePageVideosContainer from '../NonHomePageVideosContainer'
import Sidebar from '../Sidebar'
import Header from '../Header'

import {SavedVideosBgContainer} from './styledComponents'
import {
  FailureContent,
  FailureHeading,
  NoVideoImg,
  NonVideoContainer,
} from '../Home/styledComponents'

import {NonHeaderContainer} from '../TrendingRoute/styledComponents'

const SavedVideosRoute = () => {
  const renderNoVideosView = darkMode => (
    <NonVideoContainer darkMode={darkMode}>
      <NoVideoImg
        src="https://assets.ccbp.in/frontend/react-js/nxt-watch-no-saved-videos-img.png"
        alt="no saved videos"
      />
      <FailureHeading darkMode={darkMode}>No saved videos found</FailureHeading>
      <FailureContent darkMode={darkMode}>
        You can save your videos while watching them
      </FailureContent>
    </NonVideoContainer>
  )

  const renderRespectiveContainer = (videosList, darkMode) => {
    const noOfVideos = videosList.length
    if (noOfVideos === 0) {
      return renderNoVideosView(darkMode)
    }
    return (
      <NonHomePageVideosContainer
        category="Saved Videos"
        videosList={videosList}
      />
    )
  }

  return (
    <NxtWatchContext.Consumer>
      {value => {
        const {savedVideosList, darkMode} = value
        return (
          <SavedVideosBgContainer>
            <Header />
            <NonHeaderContainer data-testid="savedVideos" darkMode={darkMode}>
              <Sidebar />
              {renderRespectiveContainer(savedVideosList, darkMode)}
            </NonHeaderContainer>
          </SavedVideosBgContainer>
        )
      }}
    </NxtWatchContext.Consumer>
  )
}
export default SavedVideosRoute
